import client from "./client";

// 가입경로 선택
export const joinPathCd = locale =>
  client.get(`/api/${locale}/comCd/joinPathCd`);
// 선호하는 연락방법
export const preferContactCd1 = locale =>
  client.get(`/api/${locale}/comCd/preferContactCd1`);
export const preferContactCd2 = locale =>
  client.get(`/api/${locale}/comCd/preferContactCd2`);
export const preferContactCd3 = locale =>
  client.get(`/api/${locale}/comCd/preferContactCd3`);
export const preferContactCd4 = locale =>
  client.get(`/api/${locale}/comCd/preferContactCd4`);
export const preferContactCd5 = locale =>
  client.get(`/api/${locale}/comCd/preferContactCd5`);

export const langCd = locale => client.get(`/api/${locale}/comCd/langCd`); // 민족
export const sbjCondCd = locale => client.get(`/api/${locale}/comCd/sbjCondCd`); // 자원부문
export const smokeYn = locale => client.get(`/api/${locale}/comCd/smokeYn`); // 흡연여부
export const sickCd = locale => client.get(`/api/${locale}/comCd/sickCd`); // 병력
export const centerCd = locale => client.get(`/api/${locale}/comCd/centerCd`); // 질환구분
export const disasesCd = locale => client.get(`/api/${locale}/comCd/disasesCd`); // 대상질환
export const cencerCd = locale => client.get(`/api/${locale}/comCd/cencerCd`); // 암종
export const sbjTyCd = locale => client.get(`/api/${locale}/comCd/sbjTyCd`); // 임상시험 종류
export const entryMonth = locale =>
  client.get(`/api/${locale}/comCd/entryMonth`);
